import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import classnames from 'classnames';

import styles from './screen-reader-only.module.scss';

const ScreenReaderOnly = props => {
  const { hideNonSr, srComponent, nonSrComponent } = props;

  let ScreenReaderElement;
  let NonScreenReaderElement;

  ScreenReaderElement = cloneElement(srComponent, {
    ...srComponent.props,
    className: classnames(srComponent.props.className, styles.srOnly),
    key: 'screen-reader-element'
  });

  if (nonSrComponent) {
    NonScreenReaderElement = cloneElement(nonSrComponent, {
      ...(nonSrComponent.props || {}),
      'aria-hidden': hideNonSr,
      key: 'non-screen-reader-element'
    });
  }

  return [ScreenReaderElement, NonScreenReaderElement];
};

ScreenReaderOnly.defaultProps = {
  hideNonSr: true
};

ScreenReaderOnly.propTypes = {
  srComponent: PropTypes.element.isRequired,
  hideNonSr: PropTypes.bool,
  nonSrComponent: PropTypes.element
};

export default ScreenReaderOnly;
